import { useState } from 'react';
import { Box, Button, Grid, TextField, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
// eslint-disable-next-line no-unused-vars
import { CloudDownload } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import esLocale from 'date-fns/locale/es';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../actions';
import axios from 'axios';
// import ExportExcel from 'react-export-excel';
import ExcelIcon from '../../../assets/excel.svg';
import { getDayRange } from '../../../utils/utils';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import XLSX from 'sheetjs-style';
import FileSaver from 'file-saver';
const MySwal = withReactContent(Swal);

// const ExcelFile = ExportExcel.ExcelFile;
// const ExcelSheet = ExportExcel.ExcelSheet;
// const ExcelColumn = ExportExcel.ExcelColumn;

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  formControl: {
    marginInline: 4,
    position: 'relative',
  },
  selectLabel: {
    position: 'relative',
    top: 24,
    left: 0,
  },
  filterItem: {
    display: 'flex',
    alignItems: 'flex-end',
    paddingBottom: 8,
    marginTop: 8,
  },
  buttonExcelExport: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 'auto',
    background: '#1F6E43',
    color: theme.palette.white.main,
    '&:hover': {
      background: '#33915e',
    },
  },
  imageExcel: {
    width: '20px',
    height: '20px',
    margin: '0 4px',
  },
}));

function Export() {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles();

  const [initialDate, setInitialDate] = useState(moment().subtract(1, 'day'));
  const [endDate, setEndDate] = useState(moment());
  const [excelInfo, setExcelInfo] = useState();
  const [openExcel, setOpenExcel] = useState(false);
  const appDispatch = useDispatch();
  const organization = useSelector((state) => state.app.organization);

  const [initial] = getDayRange(initialDate);
  const [, end] = getDayRange(endDate);
  const handleExport = () => {
    MySwal.fire({
      text: '¿Los filtros corresponden a lo que quiere exportar?',
      showConfirmButton: true,
      showDenyButton: true,
      icon: 'info',
      inputValue: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: true, priority: 1 },
        });

        try {
          const requestOptions = {
            method: 'POST',
            data: {
              type: 'notificationsByClient',
              initialDate: initial.toDate(),
              endDate: end.toDate(),
              organizationId: organization.id,
            },
          };
          const url = process.env.REACT_APP_EXPORT_KPI;
          const request = await axios(url, requestOptions);
          const exportedData = request?.data?.data || [];
          const formatedData = exportedData
            .map((row) => {
              return {
                ...row,
                fechaEnvio:
                  row?.fechaEnvio?.value &&
                  moment(new Date(row.fechaEnvio.value)).format('YYYY/MM/DD HH:mm'),
              };
            })
            .sort((a, b) => {
              const dateA = moment(a.fechaEnvio);
              const dateB = moment(b.fechaEnvio);
              return dateA < dateB ? 1 : -1;
            });
          setExcelInfo(formatedData);
          setOpenExcel(true);
          appDispatch({
            type: actions.changeLoading,
            loading: { loading: false, priority: 1 },
          });
        } catch (error) {
          appDispatch({
            type: actions.changeLoading,
            loading: { loading: false, priority: 1 },
          });
        }
      }
    });
  };

  const handleCopyData = () => {
    exportToExcel(excelInfo, 'notificaciones');
    setExcelInfo(null);
    setOpenExcel(false);
  };

  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const exportToExcel = async (excelData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    // eslint-disable-next-line no-undef
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        my: 4,
      }}
    >
      <Grid
        sx={{
          display: 'flex',
          flexDirection: small ? 'column' : 'row',
          mb: 2,
        }}
      >
        <LocalizationProvider adapterLocale={esLocale} dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            label="¿Desde qué fecha?"
            inputFormat="dd/MM/yyyy"
            value={initialDate}
            onChange={(date) => setInitialDate(moment(new Date(date)))}
            renderInput={(params) => <TextField {...params} />}
            disableFuture
          />
        </LocalizationProvider>
        <Box sx={{ mx: !small ? 2 : 0, my: small ? 2 : 0, width: small ? '100%' : 'auto' }}>
          <LocalizationProvider adapterLocale={esLocale} dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="¿Hasta qué fecha?"
              inputFormat="dd/MM/yyyy"
              value={endDate}
              onChange={(date) => setEndDate(moment(new Date(date)))}
              renderInput={(params) => <TextField {...params} />}
              disableFuture
            />
          </LocalizationProvider>
        </Box>
      </Grid>
      <Box mt={small ? 0 : 1}>
        {!openExcel && (
          <Button className={classes.buttonExcelExport} variant="contained" onClick={handleExport}>
            <Box mr={2} display="flex" alignItems="center">
              <CloudDownload />
            </Box>
            Exportar notificaciones
          </Button>
        )}
        {openExcel && (
          <Button
            className={classes.buttonExcelExport}
            variant="contained"
            onClick={handleCopyData}
          >
            <img src={ExcelIcon} className={classes.imageExcel} />
            Descargar datos
          </Button>
        )}
      </Box>
    </Grid>
  );
}

const Props = {};

Export.propTypes = Props;

export default Export;
